import { jsonp } from '@ifeng-fe/ui_base';

export const getHotEvent = async () => {
    const res = await jsonp('//shankapi.ifeng.com/api/tech/hotEvents/callback', {
        jsonpCallback: 'callback',
        cache: false,
    });

    // console.log('getHotEvent', res);
    if (res && res.data) {
        return res.data;
    } else {
        return null;
    }
};
